/** Shared toast surface: used both for server-pushed messages (error:toast) and
 * local client-side confirmations (e.g. "Settings applied"), so there's one
 * consistent place for transient feedback instead of one-off in-panel messages
 * that can get wiped out by an unrelated re-render. */
export function showToast(message: string, tone: "info" | "success" | "error" = "info"): void {
  const container = document.getElementById("toast-container");
  if (!container) return;
  const toast = document.createElement("div");
  toast.className = `toast toast-${tone}`;
  toast.textContent = message;
  container.appendChild(toast);
  setTimeout(() => toast.classList.add("toast-visible"), 10);
  setTimeout(() => {
    toast.classList.remove("toast-visible");
    setTimeout(() => toast.remove(), 300);
  }, 4000);
}
